import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { ReleaseNoteUsuarioPK } from './model/release-note-usuario-pk.model';
import { ReleaseNote } from './model/release-note.model';


@Injectable({
  providedIn: 'root'
})
export class ReleaseNoteService extends DefaultService<ReleaseNote> {
  static URL = '/api/seguranca/releasenote/releasenote/v1/releasenote';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService,
  ) {
    super(
      httpClient,
      errorHandlerService,
      ReleaseNoteService.URL
    );
  }

  buscarUltimaReleaseNote(): Observable<ReleaseNote> {
    return this.httpClient.get<ReleaseNote>(`${ReleaseNoteService.URL}/buscarUltimaReleaseNote`, this.httpOptions)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

  adicionarUsuarioLeitor(idReleaseNote: number): Observable<ReleaseNoteUsuarioPK> {
    return this.httpClient.post<ReleaseNoteUsuarioPK>(`${ReleaseNoteService.URL}/adicionarUsuarioLeitor/${idReleaseNote}`, this.httpOptions)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

  adicionarUsuarioLeitorATodasNaoLidas(): Observable<ReleaseNoteUsuarioPK> {
    return this.httpClient.post<ReleaseNoteUsuarioPK>(`${ReleaseNoteService.URL}/adicionarUsuarioLeitorATodasNaoLidas`, this.httpOptions)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

}
